import axios from "axios";

export const downloadOrderFinishedScrapInventoryReport = async () => {
    try {
        const config = {
            withCredentials: true,
            headers: {
                withCredentials: true,
            },
        };
        const url = `${process.env.REACT_APP_URL
            }/api/finished-good-inventory/download-csv-orders-finished-scrap-inventory`;
        const data = await axios.get(url, config);
        return data?.data?.result;
    } catch (error) {
        console.log(error);
        return error?.response?.data?.result;
    }
};
